<template>
<div class = "guest-services">
  <div class="Breadcrumb u-desktopOnly">
    <ul>
      <li class="Breadcrumb__item">
        <a class="is-active" href="#/">{{$t("home")}}</a>
      </li>
      <li class="Breadcrumb__item">
        <span >{{$t("contactUs")}}</span>
      </li>
    </ul>
  </div>
  <div class="PageHeader">
    <h1 class="PageHeader__heading">{{ $t("contactUs") }}</h1>
  </div>
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: 'GuestServices',
  mounted () {
    document.body.className = 'guest-services-container';
    if(!this.$route.query.issue) {
      this.getConfig(true).then(() => {
        this.$router.replace('/guest-services/regionSelect');
      }).catch(err => {
        console.error(err);
      });
    }
  },
  updated: function () {
    if (this.$route.path === '/guest-services') {
      this.getConfig(true).then(() => {
        this.$router.replace('/guest-services/regionSelect');
      }).catch(err => {
        console.error(err);
      });
    } else {
      this.getConfig(false);
    }
  },
  beforeDestroy: function () {
    document.body.className = '';
  },
  data () {
    return {
      state: {},
      config: null,
      baseConfig: {
        submitTicketUrl: process.env['BASECONFIG.submitTicketUrl']
      }
    }
  },
  methods: {
    getConfig: function(nullCheck) {
      return new Promise((resolve, reject) => {
        if (this.config === null || !nullCheck) {
          let locale = window.i18n.locale
          let xhr = new XMLHttpRequest();
          xhr.open('GET', `/static/config_${locale}.json`, true);
          xhr.onload = () => {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                this.config = JSON.parse(xhr.responseText);
                resolve();
              } else {
                reject(xhr.statusText);
              }
            }
          };
          xhr.onerror = () => {
            reject(xhr.statusText);
          };
          xhr.send(null);
        } else {
          resolve();
        }
      });
    },
    getState: function() {
      return {
        region: this.getRegionById(this.state.region),
        product: this.getProductById(this.state.product),
        site: this.getSiteById(this.state.site),
        ride: this.getRideById(this.state.ride)
      }
    },
    getRegionById: function(regionId) {
      let regions = this.config.Regions;
      return regions.filter(r => r.id === regionId)[0]
    },
    getProductById: function(productId) {
      let products = this.config.Products;
      return products.filter(p => p.id === productId)[0]
    },
    getSiteById: function(siteId) {
      let sites = this.config.Sites;
      return sites.filter(s => s.id === siteId)[0]
    },
    getRideById: function(rideId) {
      let rides = this.config.Rides;
      return rides.filter(r => r.id === rideId)[0]
    }
  }
}
</script>

<style>
  body.guest-services-container {
    background: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/GuestServices/GuestServices.vue